import { connect } from 'react-redux';
import PresentationComponent from '../../../components/event/EventQueryExposureModal';
import {
  getRetentionComplexExposureError,
  getRetentionComplexFirstEvent,
  getRetentionComplexReturnEvent,
  getRetentionComplexSQL,
} from '../../../reducers/analyticsApp';
import { exposeRetentionQuery } from '../../../actions/retention/retentionComplex';

const mapStateToProps = (state) => ({
  sql: getRetentionComplexSQL(state),
  error: getRetentionComplexExposureError(state),
  updatingItems: [getRetentionComplexFirstEvent(state), getRetentionComplexReturnEvent(state)],
  showButton: true,
});

const mapDispatchToProps = (dispatch) => ({
  expose: () => dispatch(exposeRetentionQuery()),
});

const EventsQueryExposureModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(PresentationComponent);

export default EventsQueryExposureModal;
